var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('service-worker-notifications'),_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{attrs:{"id":"loading-overlay"}},[_c('HdLoadingSpinner')],1):_vm._e()]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }